import { pageViewTypes } from "@constants/tracking";
import { emptyStates } from "@features/dashboard/constants";
import useAnalytics from "@hooks/useAnalytics";
import Box from "@memorang/ui/components/Box";
import { CardContainerSkeleton } from "@memorang/ui/components/CardContainer/CardContainerSkeleton";
import OverallYourStreakCard from "@memorang/ui/components/Cards/OverallStreakCard";
import OverallYourAchievementsCard from "@memorang/ui/components/Cards/OverallYourAchievementsCard";
import OverallYourGuessDistributionCard from "@memorang/ui/components/Cards/OverallYourGuessDistributionCard";
import OverallYourProgressCard from "@memorang/ui/components/Cards/OverallYourProgressCard";
import StrengthsAndWeaknessCard from "@memorang/ui/components/Cards/StrengthsAndWeaknessCard";
import EmptyState from "@memorang/ui/components/EmptyView";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { router } from "expo-router";
import { useMemo } from "react";
import { ProgressEmptySvg } from "../../../../../assets";
import { useInsights } from "../../hooks/useInsights";
const ProgressView = () => {
	const eventsObject = useMemo(() => {
		return {
			type: pageViewTypes.progress,
		};
	}, []);
	useAnalytics(eventsObject);
	const {
		overallProgressData,
		// overallRankData,
		overallAchievementsData,
		overallGuessDistributionData,
		overallStreakData,
		strengthsAndWeaknessData,
		isLoading,
		showEmptyState,
	} = useInsights();

	if (showEmptyState && !isLoading) {
		return (
			<EmptyState
				{...emptyStates.insights}
				cta="START CHALLENGE"
				image={ProgressEmptySvg}
				handleAction={() => {
					router.push("/home");
				}}
			/>
		);
	}

	return (
		<>
			<ScrollContainer maxWidth="sm">
				{isLoading ? (
					<Box padding={16} gap={16}>
						{Array.from({ length: 5 }).map((_, cardIndex) => (
							// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton cards
							<CardContainerSkeleton key={cardIndex} />
						))}
					</Box>
				) : (
					<Box padding={16} gap={16}>
						<OverallYourProgressCard {...overallProgressData} />
						{strengthsAndWeaknessData && (
							<StrengthsAndWeaknessCard {...strengthsAndWeaknessData} />
						)}
						{/* <OverallYourRankCard {...overallRankData} /> */}
						<OverallYourAchievementsCard {...overallAchievementsData} />
						<OverallYourGuessDistributionCard
							{...overallGuessDistributionData}
						/>
						<OverallYourStreakCard {...overallStreakData} />
					</Box>
				)}
			</ScrollContainer>
		</>
	);
};

export default ProgressView;
